import React from 'react';
import '../App.scss';

const MechanismSection: React.FC = () => {
  return (
    <section id="mehanizam" className="howto-section">
      <img
        src="/ultra-original.png"
        alt="Ultra Energy Drink Original"
        className="howto-can"
      />

      <div className="howto-steps">
        <div className="howto-step">
          <span className="howto-num">1</span>
          <div className="howto-copy">
            <h3 className="howto-title">KUPI</h3>
            <p className="howto-text">
              bilo koju Ultra limenku{' '}
              <br className="howto-br-desktop" />
              0,25 ili 0,5L sa zlatnim zatvaračem
            </p>
          </div>
        </div>

        <div className="howto-step">
          <span className="howto-num">2</span>
          <div className="howto-copy">
            <h3 className="howto-title">UNESI</h3>
            <p className="howto-text">
              kod ispod zlatnog zatvarača{' '}
              <br className="howto-br-desktop" />
              na sajt <strong>ultrachallenge.rs</strong>
            </p>
          </div>
        </div>

        <div className="howto-step">
          <span className="howto-num">3</span>
          <div className="howto-copy">
            <h3 className="howto-title">OSVOJI</h3>
            <p className="howto-text">
              put u L.A. i druge sjajne{' '}
              <br className="howto-br-desktop" />
              nagrade
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MechanismSection;
